export default "__VITE_ASSET__Cii47cYK__"